import React, { useState, useEffect } from 'react';
import { apiClient } from '../../api';

interface LLMProvider {
  name: string;
  enum_value: string;
  default_rest_endpoint: string;
  icon: string;
  description: string;
  hero: {
    logo_path: string;
    width: string;
    height: string;
  };
  api_key_label: string;
  models: Array<{
    name: string;
    value: string;
    cost_per_1k_input: number;
    cost_per_1k_output: number;
  }>;
}

interface GatewayConfig {
  llm?: {
    paths?: Array<{ id: string; name: string; prefix: string }>;
    providers?: LLMProvider[];
  };
  mcp_proxies?: {
    paths?: Array<{ id: string; name: string; prefix: string }>;
  };
}

interface ProviderSelectionStepProps {
  onProviderSelect: (provider: string) => void;
  onCancel: () => void;
}

const ProviderSelectionStep: React.FC<ProviderSelectionStepProps> = ({ onProviderSelect }) => {
  const [providers, setProviders] = useState<LLMProvider[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProviders();
  }, []);

  const loadProviders = async () => {
    try {
      const response = await apiClient.get('/pipes/config');
      const config: GatewayConfig = response.data;
      if (config.llm?.providers) {
        setProviders(config.llm.providers);
      }
    } catch (err) {
      console.error('Failed to load providers:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="card shadow">
        <div className="card-body text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading providers...</span>
          </div>
          <p className="mt-3">Loading LLM providers...</p>
        </div>
      </div>
    );
  }
  return (
    <div className="card shadow">
      <div className="card-body">
        <div className="welcome-screen">
          <h2>Add New LLM Pipe</h2>
          <p>
            Configure a new LLM Pipe to connect your agents to Large Language Model providers.
            This wizard will guide you through the configuration process.
          </p>
          <p>
            <strong>First, please select your LLM provider:</strong>
          </p>

          <div className="protocol-selection">
            {providers.map(provider => (
              <button
                key={provider.enum_value}
                className="protocol-button"
                onClick={() => onProviderSelect(provider.enum_value)}
              >
                <div className="protocol-icon">
                  <img 
                    src={provider.hero.logo_path} 
                    alt={`${provider.name} logo`}
                    style={{ 
                      width: provider.hero.width || '64px', 
                      height: provider.hero.height || '64px', 
                      objectFit: 'contain' 
                    }}
                  />
                </div>
                <div className="protocol-name">{provider.name}</div>
                <div className="protocol-description">
                  {provider.description}
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProviderSelectionStep;
